import src from "IMAGE";
export default { src, width: 115, height: 29, blurWidth: 0, blurHeight: 0};
